import React, { Component } from "react";
import PropTypes from "prop-types";
import { ActivityModal } from "../../../atoms/ActivityModal";

class LoadAwareFormLayout extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    wrapperClassName: PropTypes.string,
    childrenWithProps: PropTypes.any.isRequired,
    loadingState: PropTypes.any.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <div id={this.props.id} className={this.props.wrapperClassName}>
        {this.props.childrenWithProps}
        {this.props.loading && <ActivityModal />}
      </div>
    );
  }
}

export default LoadAwareFormLayout;
